<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <fui-heading [text]="'Community Topics'" [level]="5"></fui-heading>
  <button class="btn btn-secondary" (click)="editTopic()">
    <fa-icon icon="plus"></fa-icon>
    Add
  </button>
</div>
<div class="row">
  <div class="col-md-12">
    <span>These are similar to chat rooms, members can post in them, but they wont stay around forever.</span>
    @if (topics && topics.length) {
      @for (topic of topics; track topic) {
        <myp-list-item
          [showImage]="false"
          [includeChevron]="false"
          [title]="topic.title"
          [item]="topic"
          [subData]="['Start Date: ' + (topic.start_date && topic.start_date.toDate ? (topic.start_date.toDate() | date) : ''), topic.archived ? 'ARCHIVED' : '']"
        >
          <div class="button-content">
            @if (!topic.archived) {
              <fa-icon icon="edit" placement="left" (click)="editTopic(topic)" [ngbTooltip]="'Edit'" class="action circle-icon-btn m-r-10"></fa-icon>
            }
            @if (!topic.archived) {
              <fa-icon icon="times" placement="left" (click)="archiveTopic(topic)" [ngbTooltip]="'Archive'" class="action circle-icon-btn"></fa-icon>
            }
            @if (topic.archived) {
              <fa-icon icon="check" placement="left" (click)="unArchiveTopic(topic)" [ngbTooltip]="'Un-Archive'" class="action circle-icon-btn"></fa-icon>
            }
          </div>
        </myp-list-item>
      }
    }
  </div>
</div>
